// import {
//   SortableContainer,
//   SortableElement,
//   SortableHandle,
// } from 'react-sortable-hoc';
// import arrayMove from 'array-move';

import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  useCallback,
} from 'react';
import { connect } from 'react-redux';
import actions from '@flux/action';
// import '@style/modules/insights/integrationApproach.scss';
import '../../../styles/modules/insights/integrationApproach.scss';
import Dropdown from '../insightsDropdown';
// import { Tip } from './components/titleTootip';
import { Tooltip } from 'antd';
import { Button as SubmitButton } from 'appkit-react';
import IaOption from './components/iaOption';
import AddNewElement from './components/addNewElement';
import { deepCopy } from '@utils/common';
import { produce } from 'immer';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  restrictToVerticalAxis,
  restrictToParentElement,
} from '@dnd-kit/modifiers';
import alert from '@components/alert';
import SectionComment from 'src/ddvComment/SectionComment';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';
import CategoryModal from './components/CategoryModal/CategoryModal';
import { nanoid } from 'nanoid';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { SaveAndCancelBtns } from '@components/actionButtonsGroup';

const scrollToCategoryByIndex = (index) => {
  const titleNode = document.querySelector(
    `.section-title-anchor[data-index='${index}']`,
  );
  if (titleNode) {
    // Fixed: removed extra space
    titleNode.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
};

// Replacement for SortableHandle using @dnd-kit
const DragHandle = ({ listeners, attributes }) => (
  <span
    className="appkiticon icon-menu-fill"
    {...listeners}
    {...attributes}
    style={{ cursor: 'grab' }}
  />
);

// TODO: the logic for show and hide need to adjust // comment by Sean Zhao
const ApproachComponent = ({
  currentSubmoduleName,
  onSave,
  changeLoading,
  originData,
  insightSectionKey,
  sectionName,
}) => {
  const [editingData, setEditingData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [addedOption, setAddedOption] = useState([]);
  const [modalData, setModalData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const addElementRefs = useRef([]);
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 20,
      },
    }),
    useSensor(KeyboardSensor),
  );

  useEffect(() => {
    if (originData?.length) {
      setEditingData(deepCopy(originData));
      setAddedOption(
        Array(originData?.length)
          .fill(1)
          .map(() => []),
      );
    }
  }, [originData]);

  const onOptionChange = (rowId, sectionId, contentId, type, value = null) => {
    const changedOption = produce(editingData, (draft) => {
      switch (type) {
        case 'click':
          if (draft[sectionId].data[rowId].content[contentId].data.isSelected) {
            // Fixed: removed space in "row Id"
            draft[sectionId].data[rowId].content[
              contentId
            ].data.questioned = false;
            draft[sectionId].data[rowId].content[contentId].data.value = null;
            draft[sectionId].data[rowId].content[
              contentId
            ].data.isSelected = false;
          } else {
            if (!draft[sectionId].data[rowId].canCheckMore) {
              draft[sectionId].data[rowId].content = draft[sectionId].data[
                rowId
              ].content.map((content) => {
                content.data.questioned = false;
                content.data.value = null;
                content.data.isSelected = false;
                return content;
              });
            }
            draft[sectionId].data[rowId].content[
              contentId
            ].data.isSelected = true;
          }
          break;
        case 'slider':
          draft[sectionId].data[rowId].content[contentId].data.value = value;
          break;
        case 'question':
          draft[sectionId].data[rowId].content[contentId].data.questioned =
            value;
          break;
        default:
      }
      return draft;
    });
    setEditingData(changedOption);
  };

  const handleSubmitData = async (dataToSave) => {
    changeLoading(true);
    await onSave(dataToSave.map(({ identifier, isNewAdded, ...rest }) => rest));
    setAddedOption(
      Array(dataToSave?.length)
        .fill(1)
        .map(() => []),
    );
    changeLoading(false);
    setIsEditing(false);
  };

  const reloadFromAddedOptions = (options, sectionIndex, itemInAddedOption) => {
    if (typeof itemInAddedOption.originRowId !== 'number') {
      return options;
    }

    const { originRowId, tempShow, ...originItem } = itemInAddedOption; // Fixed: removed space before comma
    const newOptions = produce(options, (draft) => {
      draft[sectionIndex].data.splice(originRowId, 0, originItem);
      return draft;
    });

    return newOptions;
  };

  const handleSave = async () => {
    const emptyCategoryIndex = editingData.findIndex((i) => !i.data?.length);
    if (emptyCategoryIndex > -1) {
      alert.warning({
        onOk() {
          setTimeout(() => {
            scrollToCategoryByIndex(emptyCategoryIndex);
          }, 100);
        },
        content: 'At least one element should be added in category',
      });
      return;
    }
    if (!addedOption.every((addItem) => !addItem.length)) {
      const currentEditDataList = new Array(3).fill(null);
      for (let i = 0; i < addElementRefs.current?.length; i++) {
        if (typeof addElementRefs.current?.[i]?.validate === 'function') {
          // eslint-disable-next-line no-await-in-loop
          const optionData = await addElementRefs.current?.[i]?.validate();
          if (optionData) {
            currentEditDataList[i] = optionData;
          } else {
            document.querySelector(`.approach-edit-element-${i}`) &&
              document
                .querySelector(`.approach-edit-element-${i}`)
                .scrollIntoViewIfNeeded();
            return;
          }
        }
      }
      alert.confirmWithSave({
        content: 'Do you want to save the element in editing?',
        cancelText: 'no',
        okText: 'yes',
        onOk: () => {
          const dataToSave = produce(editingData, (draft) => {
            currentEditDataList.forEach((option, sectionIndex) => {
              if (!option) {
                return;
              }
              const originRowId = addedOption[sectionIndex][0]?.originRowId; // Fixed: removed space in "section Index"
              if (originRowId) {
                draft[sectionIndex].data.splice(originRowId, 0, option);
              } else {
                // new added row
                draft[sectionIndex].data.push(option);
              }
            });
          });
          handleSubmitData(dataToSave);
        },
        onCancel: (close) => {
          // if click x button on the top right, will not exit the editmode or reset data
          if (!close?.triggerCancel) {
            let newOption = deepCopy(editingData);

            // reload data from addedOption to editing data
            for (const sectionIndex in addedOption) {
              for (const item of addedOption[sectionIndex]) {
                newOption = reloadFromAddedOptions(
                  newOption,
                  sectionIndex,
                  item,
                );
              }
            }

            handleSubmitData(newOption);
          }

          typeof close === 'function' && close();
        },
      });

      return;
    }
    await handleSubmitData(editingData);
  };

  const saveForCancelButton = async () => {
    const emptyCategoryIndex = editingData.findIndex((i) => !i.data?.length);
    if (emptyCategoryIndex > -1) {
      alert.warning({
        onOk() {
          setTimeout(() => {
            scrollToCategoryByIndex(emptyCategoryIndex);
          }, 100);
        },
        content: 'At least one element should be added in category',
      });
      return;
    }
    if (!addedOption.every((addItem) => !addItem.length)) {
      const currentEditDataList = new Array(3).fill(null);
      for (let i = 0; i < addElementRefs.current?.length; i++) {
        if (typeof addElementRefs.current?.[i]?.validate === 'function ') {
          // eslint-disable-next-line no-await-in-loop
          const optionData = await addElementRefs.current?.[i]?.validate(); // Fixed: removed space in "addElement Refs"
          if (optionData) {
            currentEditDataList[i] = optionData;
          } else {
            document.querySelector(`.approach-edit-element-${i}`) &&
              document
                .querySelector(`.approach-edit-element-${i}`)
                .scrollIntoViewIfNeeded();
            return;
          }
        }
      }
      const dataToSave = produce(editingData, (draft) => {
        currentEditDataList.forEach((option, sectionIndex) => {
          if (option) {
            const originRowId = addedOption[sectionIndex][0]?.originRowId;
            if (originRowId) {
              draft[sectionIndex].data.splice(originRowId, 0, option);
            } else {
              // new added row
              draft[sectionIndex].data.push(option);
            }
          }
        });
      });
      await handleSubmitData(dataToSave);
    } else {
      await handleSubmitData(editingData);
    }
  };

  const onConfirmLeaving = (close) => {
    // if click x button on the top right, will not exit the editmode or reset data
    if (!close?.triggerCancel) {
      setEditingData(deepCopy(originData));
      setAddedOption(
        Array(originData?.length)
          .fill(1)
          .map(() => []),
      );
      setIsEditing(false);
    }

    typeof close === 'function' && close();
  };

  const handleCancel = () => {
    if (
      JSON.stringify(originData) === JSON.stringify(editingData) &&
      addedOption.every((addItem) => !addItem.length)
    ) {
      setEditingData(deepCopy(originData));
      setAddedOption(
        Array(originData?.length)
          .fill(1)
          .map(() => []),
      );
      setIsEditing(false);
    } else {
      alert.confirm({
        // Fixed: removed space
        onOk: saveForCancelButton,
        okText: 'no',
        cancelText: 'yes',
        content: 'Do you want to leave without saving the change?',
        onCancel: onConfirmLeaving,
        async: true,
        maskClosable: true,
      });
    }
  };

  // add element in certain section
  // tempShow is for added too many element then delete them
  const addNewElement = (sectionId, option, rowId) => {
    if (addedOption[sectionId].filter((a) => a.tempShow).length > 0) {
      return;
    }
    if (!option) {
      addedOption[sectionId].push({ title: '', tempShow: true });
    } else {
      // edit manual option
      editingData[sectionId].data.splice([rowId], 1);
      setEditingData([...editingData]);
      addedOption[sectionId].push({
        ...option,
        tempShow: true,
        originRowId: rowId,
      });
    }
    setAddedOption([...addedOption]);
  };

  const cancelCallback = (sectionIndex, addItem) => {
    const newOptions = reloadFromAddedOptions(
      editingData,
      sectionIndex,
      addItem,
    );
    setEditingData(newOptions);

    addedOption[sectionIndex] = [];
    setAddedOption([...addedOption]);
  };

  const addCallback = (
    sectionIndex,
    data,
    indexInAddedOption,
    originRowIndex,
  ) => {
    const tempData = produce(editingData, (draft) => {
      if (typeof originRowIndex !== 'undefined') {
        draft[sectionIndex].data.splice(originRowIndex, 0, data);
      } else {
        draft[sectionIndex].data.push(data);
      }
      draft[sectionIndex].addOption = [];
      return draft;
    });
    setEditingData(tempData); // Fixed: removed comment and extra line
    const tempAddedOption = produce(addedOption, (draft) => {
      // draft[sectionIndex][indexInAddedOption].tempShow = false;
      draft[sectionIndex] = [];
      return draft;
    });
    setAddedOption([...tempAddedOption]);
  };

  // Replacement for SortableElement using @dnd-kit
  const SortableRows = ({ value }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: `${value.sectionId}-${value.i}`,
    });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      opacity: isDragging ? 0.5 : 1,
    };

    return (
      <div ref={setNodeRef} style={style} {...attributes}>
        <SectionComponent
          value={value}
          dragHandleProps={{ listeners, attributes }}
        />
      </div>
    );
  };

  const SectionComponent = ({ value, dragHandleProps }) => {
    const { option, sectionId, i, lengthWithHidden } = value;

    return (
      <div
        className={`row ${i === 0 ? 'first' : ''} ${
          i === lengthWithHidden - 1 ? 'last' : ''
        }`}
        key={`key-ia-${i}`}
      >
        <div className="title">
          <div className="edit-area">
            {isEditing ? (
              <>
                {/* drag handler */}
                <DragHandle {...dragHandleProps} />
                {/* show/hide icon */}
                <span
                  className={`appkiticon icon-view-fill ${
                    option.isShow ? '' : 'invisible'
                  }`}
                  onClick={() => {
                    const tempObj = produce(editingData, (draft) => {
                      draft[sectionId].data[i].isShow = // Fixed: removed extra space
                        !draft[sectionId].data[i].isShow;
                      return draft;
                    });
                    setEditingData([...tempObj]);
                  }}
                />
                {/* remove */}
                {option.userAdded ? (
                  <span
                    className="appkiticon icon-circle-delete-fill"
                    onClick={() => {
                      const tempObj = produce(editingData, (draft) => {
                        draft[sectionId].data.splice(i, 1);
                        return draft;
                      });
                      setEditingData([...tempObj]);
                    }}
                  />
                ) : null}
              </>
            ) : null}
          </div>
          {/* subtitle */}
          <div className="text-area">
            <div className="title-text">{option.title}</div>
            {option.subtitle ? (
              <Tooltip
                title={<div className="subtitle">{option.subtitle}</div>}
                placement="bottomLeft"
                overlayClassName="integration-title-tooltip"
                align={{
                  offset: [-17, 0],
                }}
                getPopupContainer={() =>
                  document.getElementsByClassName('ia-content-bottom')[0]
                }
              >
                <span className="appkiticon icon-information-fill" />
              </Tooltip>
            ) : null}
            {/* edit icon */}
            {isEditing ? (
              <span
                className="appkiticon icon-pencil-fill"
                onClick={() => {
                  addNewElement(sectionId, option, i);
                }}
              />
            ) : null}
          </div>
        </div>
        <div
          className={`option-content option-count-${option.content?.length}`}
        >
          {option.content.map((content, j) => (
            <IaOption
              key={`key-ia-option-${j}`}
              name={content.name}
              onClick={(type, value) => {
                onOptionChange(i, sectionId, j, type, value); // Fixed: removed extra space
              }}
              data={{
                value: content.data.value,
                questioned: content.data.questioned,
                isSelected: content.data.isSelected,
              }}
              isEditing={isEditing}
              canCheckMore={option.canCheckMore}
            />
          ))}
        </div>
      </div>
    );
  };

  const handleDragEnd = (event, sectionId) => {
    const { active, over } = event;

    if (active.id !== over?.id) {
      const [, activeIndex] = active.id.split('-');
      const [, overIndex] = over.id.split('-');

      const oldIndex = parseInt(activeIndex);
      const newIndex = parseInt(overIndex);

      const tempObj = produce(editingData, (draft) => {
        const tempOptionData = arrayMove(
          draft[sectionId].data,
          oldIndex,
          newIndex,
        );
        draft[sectionId].data = tempOptionData;
        return draft;
      });
      setEditingData([...tempObj]);
    }
  };

  const openModal = useCallback(() => {
    setModalData(
      produce(editingData, (draft) => {
        draft.forEach((item, index) => {
          item.addOption = addedOption[index];
          if (!item.identifier) {
            item.identifier = nanoid();
          }
          return item;
        });
        return draft;
      }),
    );
    setModalVisible(true);
  }, [editingData, addedOption]);

  const onModalOk = useCallback((orderedData) => {
    const nextAddedOption = orderedData.map((i) =>
      Array.isArray(i.addOption) ? i.addOption : [],
    );
    setEditingData(
      produce(orderedData, (draft) => {
        draft.forEach((i) => {
          if (!i.data) {
            i.data = [];
          }
          Reflect.deleteProperty(i, 'addOption'); // Fixed: removed extra space
        });
        return draft;
      }),
    );
    setAddedOption(nextAddedOption);
    setModalVisible(false);
    const newItemIndex = orderedData.findIndex((i) => i.isNewAdded);
    if (newItemIndex !== -1) {
      setTimeout(() => {
        scrollToCategoryByIndex(newItemIndex);
      }, 300);
    }
  }, []);

  const onModalCancel = useCallback(() => {
    setModalVisible(false);
  }, []);

  return (
    <div className="insights-approach-container">
      <Dropdown section={insightSectionKey} />
      <SectionComment module={currentSubmoduleName} placement="bottomRight" />
      <div className={`ia-content-bottom ${isEditing ? 'editing' : ''}`}>
        <div className="column-titles">
          <div className="column-titles-left">
            Decision Elements
            {isEditing ? (
              <SubmitButton
                className="cancel-btn customize-category-btn"
                kind="secondary"
                size="lg"
                onClick={openModal}
              >
                Customize Category
              </SubmitButton>
            ) : null}
          </div>
          <div>
            {sectionName} Options and Tradeoffs
            <div className="button-area role-control">
              {isEditing ? (
                <>
                  <SaveAndCancelBtns
                    handleSave={handleSave}
                    handleBack={handleCancel}
                  />
                </>
              ) : isInternal ? (
                <SubmitButton
                  className="save-btn"
                  kind="primary"
                  size="lg"
                  onClick={() => {
                    setIsEditing(true);
                  }}
                >
                  Edit
                </SubmitButton>
              ) : null}
            </div>
          </div>
        </div>
        <div className="approach-information-legend">
          <div className="first-level">
            {' '}
            <i />
            Likely direction for deal – draft for discussion
          </div>
          <div className="second-level">
            <span
              className="appkiticon icon-help-question-fill"
              style={{ fontSize: '0.875rem' }}
            />
            Open questions to confirm with Integration leadership
          </div>
          <div className="third-level">
            <div className="icon">
              <CaretDownOutlined style={{ fontSize: '0.625rem' }} />
              <CaretUpOutlined style={{ fontSize: '0.625rem' }} />
            </div>
            Directional magnitude
          </div>
        </div>
        {editingData && editingData[0]
          ? editingData.map((option, sectionIndex) => {
              const items = option.data
                .map((_, rowIndex) => `${sectionIndex}-${rowIndex}`)
                .filter(
                  (_, rowIndex) => isEditing || option.data[rowIndex].isShow,
                );

              return (
                <Fragment key={option.sectionTitle}>
                  <div className="section-title">
                    {option.sectionTitle}
                    <span
                      className="section-title-anchor"
                      data-index={sectionIndex}
                    />
                  </div>

                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={(event) => handleDragEnd(event, sectionIndex)}
                    modifiers={[
                      restrictToVerticalAxis,
                      restrictToParentElement,
                    ]}
                  >
                    <SortableContext
                      items={items}
                      strategy={verticalListSortingStrategy}
                    >
                      <div className="sort-list-section">
                        {option.data.map((optionRow, rowIndex) =>
                          isEditing || optionRow.isShow ? (
                            <SortableRows
                              key={`${sectionIndex}-${rowIndex}`}
                              value={{
                                option: optionRow,
                                sectionId: sectionIndex, // Fixed: removed space
                                i: rowIndex,
                                // TODO: might have drag disorder problem // comment by Sean Zhao
                                length: option.data.length,
                              }}
                            />
                          ) : null,
                        )}
                      </div>
                    </SortableContext>
                  </DndContext>

                  {isEditing
                    ? addedOption[sectionIndex].map((addItem, j) =>
                        addItem.tempShow || addItem.data ? (
                          <AddNewElement
                            key={j}
                            sectionIndex={sectionIndex}
                            ref={(elementRef) => {
                              addElementRefs.current[sectionIndex] = elementRef;
                            }}
                            addCallback={(data) => {
                              addCallback(
                                sectionIndex,
                                data,
                                j,
                                addItem.originRowId,
                              );
                            }}
                            cancelCallback={() => {
                              cancelCallback(sectionIndex, addItem);
                            }}
                            data={addItem}
                            allElementNames={editingData.map((f) =>
                              f.data.map((m) => m.title),
                            )}
                          />
                        ) : null,
                      )
                    : null}
                  {isEditing ? (
                    <div
                      className={`add-new-element-button ${
                        addedOption[sectionIndex].filter((a) => a.tempShow)
                          .length > 0
                          ? 'disable'
                          : ''
                      }`}
                      onClick={() => {
                        addNewElement(sectionIndex);
                      }}
                    >
                      <span className="appkiticon icon-circle-plus-fill" />
                      Add New Element{' '}
                    </div>
                  ) : null}
                </Fragment>
              );
            })
          : null}
      </div>
      <CategoryModal
        visible={modalVisible}
        onCancel={onModalCancel} // Fixed: removed space
        onOk={onModalOk}
        data={modalData}
      />
    </div>
  );
};

const mapStateToProps = ({ common, projects, login }) => {
  const projectId = common.currentId;
  return {
    projectId,
    // permission: projects.sectionsPermission.insightPermission,
    userInfo: login.userInfo || {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeLoading(flag) {
    dispatch(actions.changeLoading(flag));
  },
});

export default CommentAnchor(
  connect(mapStateToProps, mapDispatchToProps)(React.memo(ApproachComponent)),
  {
    shouldScrollInToView: (anchorRecord, anchorId) =>
      anchorRecord?.moduleName === anchorId,
    getAnchorIdFromProp: (props) => props.currentSubmoduleName,
  },
);
